// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Zg6ZZ","buttons":"Footer_buttons__1nJXX"};